import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.REACT_APP_ENCRYPTION_KEY ||
  "9f6c8a2d41b7e3f0a5d9c2e8b1f6a0c4e7d3b9a2f5c8e1d6a4b0f7c9e2";

  const isMongoId = (id) =>
  typeof id === "string" && /^[a-fA-F0-9]{24}$/.test(id);
export const encryptId = (id) => {
  const encrypted = CryptoJS.AES.encrypt(String(id), SECRET_KEY).toString();
  // 🔑 MAKE IT URL SAFE
  return encodeURIComponent(encrypted);
};

export const decryptId = (encryptedId,keySecret=SECRET_KEY) => {
  try {
    if (!encryptedId) return null;
    if (isMongoId(encryptedId)) return encryptedId;
    const decoded = decodeURIComponent(encryptedId);
    const bytes = CryptoJS.AES.decrypt(decoded, keySecret);
    const result = bytes.toString(CryptoJS.enc.Utf8);
    return result || null;
  } catch {
    return null;
  }
};
